import { useAppDispatch, useAppSelector } from 'app/hooks';
import { MOBILE_ORDER_DISPLAY_ONLY_EDITED } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import {
  selectStoreSettingDetailDisplayType,
  selectStoreSettingDetailExpandAll,
  selectStoreSettingEditedMenuBookIds,
  storeSettingDetailActions,
} from 'features/Store/storeSettingDetailSlice';
import { countMenuBookHasEditedMObileOrderDisplayFlg, getIsExpandStatus } from 'features/Store/utils';
import React, { useEffect, useState } from 'react';
import { MINUS_TEXT, PLUS_TEXT } from 'utils';
import { MenuBook } from '../../models';

export interface MenuBookRowCollapseProps {
  menuBook: MenuBook;
  children?: React.ReactNode;
}

function MenuBookRow({ menuBook, children }: MenuBookRowCollapseProps) {
  const dispatch = useAppDispatch();
  const editedMenuBookIds = useAppSelector(selectStoreSettingEditedMenuBookIds);
  const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);
  const displayType = useAppSelector(selectStoreSettingDetailDisplayType);

  const [open, setOpen] = useState(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));

  const pathId = `${menuBook.id}`;

  useEffect(() => {
    const btnExpandElem = document.querySelector(`#menubook-${pathId}-row .dan-btn-expand`) as HTMLButtonElement;
    function handleBtnExpandElemClick(event: MouseEvent) {
      event.stopPropagation();
      setOpen(!open);
      dispatch(storeSettingDetailActions.setExpandAll(undefined));
      btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
      btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    if (btnExpandElem) {
      btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
    }

    return () => {
      if (btnExpandElem) {
        btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, displayType]);

  useEffect(() => {
    if (isExpand !== undefined) {
      setOpen(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpand]);

  const countTotalEditedMobileOrderDisplay = countMenuBookHasEditedMObileOrderDisplayFlg(menuBook);
  if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && countTotalEditedMobileOrderDisplay === 0) {
    return null;
  }

  return (
    <>
      <div id={`menubook-${pathId}-row`} className="dan-tr main content-visibility-auto">
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[0]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`menubook-${pathId}-content`}
            aria-expanded={open}
          >
            {open ? MINUS_TEXT : PLUS_TEXT}
          </button>
          <span>{menuBook.name}</span>
        </div>
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(1, 17).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
      </div>
      <div style={{ contentVisibility: open ? 'auto' : 'hidden' }}>
        <div id={`menubook-${pathId}-content`}>{children}</div>
      </div>
    </>
  );
}

export default MenuBookRow;
